import React, { useEffect, useState } from "react";

function RelatorioImoveis() {
  const [imoveis, setImoveis] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("/api/imoveis", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setImoveis(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erro ao buscar imóveis:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold text-blue-600 mb-4">Relatório de Imóveis</h2>

      {loading ? (
        <p>Carregando dados...</p>
      ) : imoveis.length === 0 ? (
        <p>Nenhum imóvel encontrado.</p>
      ) : (
        <table className="w-full bg-white shadow rounded">
          <thead className="bg-gray-200 text-gray-700">
            <tr>
              <th className="p-3 text-left">Endereço</th>
              <th className="p-3 text-left">Município</th>
              <th className="p-3 text-left">Estado</th>
              <th className="p-3 text-left">Proprietário</th>
              <th className="p-3 text-left">Locatário</th>
              <th className="p-3 text-left">Tipo</th>
            </tr>
          </thead>
          <tbody>
            {imoveis.map((item) => (
              <tr key={item.id} className="border-t">
                <td className="p-3">{item.endereco}</td>
                <td className="p-3">{item.municipio}</td>
                <td className="p-3">{item.estado}</td>
                <td className="p-3">{item.proprietario}</td>
                <td className="p-3">{item.locatario}</td>
                <td className="p-3">{item.tipo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default RelatorioImoveis;
